import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const Preview = ({
  size = 16,
  title = 'Preview',
  fill = colors.boulder,
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 14 10">
      {Boolean(title) && <title>{title}</title>}
      <path
        d="M13.74,4.27l-.09-.1h0C11.51,1.43,9.28,0,7,0S2.49,1.41.28,4.19a1.32,1.32,0,0,0,0,
          1.62C2.48,8.59,4.76,10,7,10s4.53-1.46,6.7-4.27A1.13,1.13,0,0,0,13.74,4.27Zm-.9.78C10.89,
          7.56,8.94,8.85,7,8.88S3.15,7.61,1.16,5.12a.25.25,0,0,1,0-.11.23.23,0,0,1,0-.14c2-2.5,
          4-3.76,5.87-3.76s3.86,1.31,5.81,3.83h0v.1Z"
        fill={fill}
      />
      <path
        d="M7,2.76A2.23,2.23,0,1,0,9.23,5,2.24,2.24,0,0,0,7,2.76Zm.72,3A1,1,0,0,1,6,5,1,1,0,1,
          1,8,5a1,1,0,0,1-.29.71Z"
        fill={fill}
      />
    </svg>
  );
};
